import React from 'react';

const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M20,.92v.53c0,.8-.13,1.18-.92,1.18H1.18A1,1,0,0,1,0,1.45V.92C0,.13.4,0,1.18,0h17.9C19.91,0,20,.14,20,.92ZM13.68,18.29c0,1.33-.14,1.71-1.44,1.71H8c-1.32,0-1.71-.38-1.71-1.71V12.63H1.18l9-9,8.95,9h-5.4Z" />
  </svg>
);

export default UploadIcon;
